export const getChatSubject = (selectedEmployees, currentUser) => {
  const othersEmployees = selectedEmployees.map(employee =>
    employee.isOwner ? employee.firstName : `${employee.firstName.charAt(0)}. ${employee.lastName}`,
  );
  const currentUserFullName = `${currentUser.first_name.charAt(0)}. ${currentUser.last_name}`;
  return [...othersEmployees, currentUserFullName].sort().join(', ');
};
